import { render, staticRenderFns } from "./PageRecetteEdition.vue?vue&type=template&id=3aa59b1e&"
import script from "./PageRecetteEdition.vue?vue&type=script&lang=js&"
export * from "./PageRecetteEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports